import { PersonConfigFile, PersonConfigFileJson } from '@models/person-config-file';

export interface PersonConfigJson {
  emails: string[];
  person_config_files: PersonConfigFileJson[];
}

export class PersonConfig {
  constructor(
    public emails?: string[],
    public personConfigFiles?: PersonConfigFile[]
  ) {}

  static fromJson(json: Partial<PersonConfigJson>): PersonConfig {
    return new PersonConfig(
      json.emails,
      json.person_config_files?.length
        ? json.person_config_files.map((file: PersonConfigFileJson) => PersonConfigFile.fromJson(file))
        : []
    );
  }

  static toJson(model: PersonConfig): Partial<PersonConfigJson> {
    return {
      emails: model.emails
    };
  }
}
